import React, { useEffect, useState } from "react";
import SkeletonTable from "../../../components/table/SkeletonTable.jsx";
import columns from "../../../columns/returnToGov/viewReturnToGov.js";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import {
  GetOrganizerAnswerApi,
  CompleteReturnToGovApi,
  ResenOrganizerPdf,
  AutoPaymentApprovedApi,
  DeleteSignature,
} from "../../../api/request/taskManager/taskManager.js";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Button, Spin } from "antd";
import PdfLink from "../../../components/common/PdfLink.jsx";
import { getSocket } from "../../../services/Socket.js";
import { useSelector } from "react-redux";
import ConfirmationModal from "../../../components/modals/ConfirmationModal.jsx";
import Close from "../../../assets/Close.jsx";
import OrganizerPdfModal from "../../followUp/components/OrganizerPdfModal.jsx";

export default function ViewReturnToGov() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [data, setData] = useState([]);
  const [clientData, setClientData] = useState({});
  const socket = getSocket();
  const { userDetails } = useSelector((state) => state.user);
  const [isResendOpen, setIsResendOpen] = useState(false);
  const [isResendLoading, setIsResendLoading] = useState(false);
  const [signType, setSignType] = useState("");
  const [isDeleteSignOpen, setIsDeleteSignOpen] = useState(false);
  const [isDeleteSignLoading, setIsDeleteSignLoading] = useState(false);
  const [isAutoPaymentOpen, setIsAutoPaymentOpen] = useState(false);
  const [isAutoPaymentLoading, setIsAutoPaymentLoading] = useState(false);
  const [isOrganizerPdfOpen, setIsOrganizerPdfOpen] = useState(false);
  const [isSpouse, setIsSpouse] = useState(false);

  const getAnswer = async () => {
    try {
      setIsLoading(true);
      let params = { organizer_id: id };
      const { data } = await GetOrganizerAnswerApi(params);
      if (data?.status) {
        setIsSpouse(Number(data?.is_spouse) === 1);
        setClientData(data?.client_selected_org);
        setData(
          data?.data?.map((section) => {
            return {
              ...section,
              questions: section?.questions?.map((question) => {
                return {
                  ...question,
                  question: (
                    <div
                      className={`${
                        !question?.reviewed_checked
                          ? "font-semibold highlight-text"
                          : ""
                      }`}
                    >
                      {question?.field_label || "--"}
                    </div>
                  ),
                  review: (
                    <div>
                      <img
                        className="size-7"
                        src={
                          question?.reviewed_checked
                            ? "/assets/icons/outlined-check-circle.svg"
                            : "/assets/icons/outlined-circle.svg"
                        }
                      />
                    </div>
                  ),
                };
              }),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAnswer();
  }, []);

  const completeTask = async () => {
    try {
      setIsSubmitLoading(true);
      const { data } = await CompleteReturnToGovApi({ organizer_id: id });
      if (data?.status) {
        toast.success(data?.message);
        socket.emit(
          "updateTask",
          JSON.stringify({ task: 5, userId: clientData?.user_id })
        );
        navigate("/e_file");
      }
      setIsSubmitLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsSubmitLoading(false);
    }
  };

  const handleResendSignature = async () => {
    try {
      setIsResendLoading(true);
      const { data } = await ResenOrganizerPdf({ organizer_id: id });
      if (data?.status) {
        toast.success(data?.message);
        setIsResendOpen(false);
        setIsResendLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsResendLoading(false);
    }
  };

  const handleDeleteSignature = async () => {
    try {
      const params = {
        organizer_id: id,
        type: signType,
      };
      setIsDeleteSignLoading(true);
      const { data } = await DeleteSignature(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsDeleteSignOpen(false);
        setClientData((prevData) => ({
          ...prevData,
          auth_pdf:
            signType === "authorization"
              ? { ...prevData.auth_pdf, url: null }
              : prevData.auth_pdf,
          gst_pdf:
            signType === "gst"
              ? { ...prevData.gst_pdf, url: null }
              : prevData.gst_pdf,
          organizer_pdf:
            signType === "organizer"
              ? { ...prevData.organizer_pdf, url: null }
              : prevData.organizer_pdf,
        }));
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setIsDeleteSignLoading(false);
    }
  };

  const handleAutoPayment = async () => {
    try {
      setIsAutoPaymentLoading(true);
      const { data } = await AutoPaymentApprovedApi({ organizer_id: id });
      if (data?.status) {
        toast.success(data?.message);
        setIsAutoPaymentOpen(false);
        setIsAutoPaymentLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsAutoPaymentLoading(false);
    }
  };

   const openOranaizerPdfModel = () => {
    setIsOrganizerPdfOpen(true);
  }

  return (
    <div className="mb-6">
      <div className="border-2 rounded-xl p-5">
        {isLoading ? (
          <div className="flex justify-center flex-col mt-[20%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <>
            <div className="flex justify-between gap-5 mb-4">
              <div>
                {clientData?.user && (
                  <div className="flex items-center gap-3">
                    <p className="font-semibold text-xl capitalize">
                      {clientData?.user?.name}
                    </p>
                    <p
                      className="text-blue-500 underline cursor-pointer"
                      onClick={() => navigate(`/client/${clientData?.user_id}`)}
                    >
                      View
                    </p>
                  </div>
                )}
              </div>
              <div className="flex items-center gap-6">
                {clientData?.auth_pdf?.url && (
                  <div className="flex items-center gap-1">
                    <PdfLink
                      text={"Authorization"}
                      data={clientData?.auth_pdf}
                    />
                    <p
                      className="cursor-pointer"
                      onClick={() => {
                        setIsDeleteSignOpen(true);
                        setSignType("authorization");
                      }}
                    >
                      <Close />
                    </p>
                  </div>
                )}
                {clientData?.gst_pdf?.url && (
                  <div className="flex items-center gap-1">
                    <PdfLink text={"GST"} data={clientData?.gst_pdf} />
                    <p
                      className="cursor-pointer"
                      onClick={() => {
                        setIsDeleteSignOpen(true);
                        setSignType("gst");
                      }}
                    >
                      <Close />
                    </p>
                  </div>
                )}
                {clientData?.organizer_pdf?.url && (
                  <div className="flex items-center gap-1">
                    <PdfLink
                      text={"Tax Return"}
                      data={clientData?.organizer_pdf}
                    />
                    <p
                      className="cursor-pointer"
                      onClick={() => {
                        setIsDeleteSignOpen(true);
                        setSignType("organizer");
                      }}
                    >
                      <Close />
                    </p>
                  </div>
                )}
                <Button
                  type="primary"
                  className="uppercase"
                  onClick={() => setIsResendOpen(true)}
                >
                  Resend Signature
                </Button>
                <Button
                  type="primary"
                  className="uppercase"
                  onClick={() => setIsAutoPaymentOpen(true)}
                  disabled={clientData?.is_payment === 2}
                >
                  Payment
                </Button>
              </div>
            </div>

            <div className="flex justify-end items-center gap-2 cursor-pointer font-semibold text-primary underline" onClick={openOranaizerPdfModel}>
                Manual PDF Signature Send
            </div>

            {data?.map((item, index) => (
              <div className="table-radius-0 text-light mb-10">
                <p className="font-semibold text-xl text-primary mb-5">
                  {`Section ${index + 1}:`} {item?.section_name}
                </p>
                <SkeletonTable
                  columns={columns}
                  data={item?.questions}
                  isLoading={isLoading}
                />
              </div>
            ))}

            <LoadableButton
              className="bg-primary text-white uppercase text-base font-semibold mt-2 py-2 rounded-lg px-4"
              type="button"
              lable="Complete Task"
              loadingLable="Completing Task..."
              isLoading={isSubmitLoading}
              onClick={completeTask}
            />
          </>
        )}
      </div>

      {/* Resend signature */}
      <ConfirmationModal
        type="success"
        isOpen={isResendOpen}
        setIsOpen={setIsResendOpen}
        message="Are you sure, want to resend signature request?"
        onConfirm={() => handleResendSignature()}
        isLoading={isResendLoading}
        loadingLabel="Sending..."
      />

      {/* Organizer Pdf Modal */}
      <OrganizerPdfModal
        isOpen={isOrganizerPdfOpen}
        setIsOpen={setIsOrganizerPdfOpen}
        isSpouse={isSpouse}
        clientData={clientData}
        organizerId={id}
      />

      {/* Delete signature */}
      <ConfirmationModal
        type="success"
        isOpen={isDeleteSignOpen}
        setIsOpen={setIsDeleteSignOpen}
        message="Are you sure, want to delete signature request?"
        onConfirm={() => handleDeleteSignature()}
        isLoading={isDeleteSignLoading}
        loadingLabel="Deleting..."
      />

      {/* Payment */}
      <ConfirmationModal
        type="success"
        isOpen={isAutoPaymentOpen}
        setIsOpen={setIsAutoPaymentOpen}
        message="Are you sure, want complete the payment?"
        onConfirm={() => handleAutoPayment()}
        isLoading={isAutoPaymentLoading}
        loadingLabel="Requesting..."
      />
    </div>
  );
}
